import React, { useState } from 'react';
import { ChevronDown, Activity, Calendar, BarChart2, History } from 'lucide-react';
import { Timeframe } from '../data/mockData';
export type DashboardTab = 'current' | 'historical';
interface DashboardHeaderProps {
  timeframe: Timeframe;
  setTimeframe: (timeframe: Timeframe) => void;
  activeTab: DashboardTab;
  setActiveTab: (tab: DashboardTab) => void;
}
export function DashboardHeader({
  timeframe,
  setTimeframe,
  activeTab,
  setActiveTab
}: DashboardHeaderProps) {
  const timeframes: Timeframe[] = ['Today', 'Last 7 Days', 'Last 30 Days', 'Month to Date', 'Custom Range'];
  const today = new Date().toISOString().split('T')[0];
  const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(thirtyDaysAgo);
  const [endDate, setEndDate] = useState(today);
  return <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-4 px-6 bg-slate-900/80 border-b border-slate-800 sticky top-0 z-10 backdrop-blur-md gap-4" data-id="element-34">
      <div className="flex items-center gap-3" data-id="element-35">
        <div className="p-2 bg-cyan-500/20 rounded-lg border border-cyan-500/30" data-id="element-36">
          <Activity className="w-6 h-6 text-cyan-400" data-id="element-37" />
        </div>
        <div data-id="element-38">
          <h1 className="text-2xl font-bold text-white tracking-tight leading-tight" data-id="element-39">
            Loan Officer War Room
          </h1>
          <p className="text-sm text-slate-400" data-id="element-40">Performance Command Center</p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-end sm:items-center gap-4 w-full sm:w-auto" data-id="element-41">
        {/* Tab Switcher */}
        <div className="flex bg-slate-800/80 p-1 rounded-lg border border-slate-700 w-full sm:w-auto" data-id="element-42">
          <button onClick={() => setActiveTab('current')} className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all ${activeTab === 'current' ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/30 shadow-sm' : 'text-slate-400 hover:text-slate-200 hover:bg-slate-700/50 border border-transparent'}`} data-id="element-43">
            <BarChart2 className="w-4 h-4" data-id="element-44" />
            Current
          </button>
          <button onClick={() => setActiveTab('historical')} className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-all ${activeTab === 'historical' ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30 shadow-sm' : 'text-slate-400 hover:text-slate-200 hover:bg-slate-700/50 border border-transparent'}`} data-id="element-45">
            <History className="w-4 h-4" data-id="element-46" />
            Historical
          </button>
        </div>

        {/* Timeframe selector (only show on current tab) */}
        {activeTab === 'current' && <div className="flex items-center gap-3 flex-wrap animate-in fade-in duration-200" data-id="element-47">
            <div className="relative group" data-id="element-48">
              <select value={timeframe} onChange={e => setTimeframe(e.target.value as Timeframe)} className="appearance-none bg-slate-800 border border-slate-700 text-white py-2 pl-4 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent cursor-pointer font-medium shadow-sm hover:bg-slate-750 transition-colors" data-id="element-49">
                {timeframes.map(tf => <option key={tf} value={tf} data-id="element-50">
                    {tf}
                  </option>)}
              </select>
              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none group-hover:text-white transition-colors" data-id="element-51" />
            </div>

            {timeframe === 'Custom Range' && <div className="flex items-center gap-2 animate-in fade-in slide-in-from-right-2 duration-200" data-id="element-52">
                <div className="relative" data-id="element-53">
                  <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-54" />
                  <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} max={endDate} className="bg-slate-800 border border-slate-700 text-white text-sm py-2 pl-9 pr-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent font-medium shadow-sm hover:bg-slate-750 transition-colors [color-scheme:dark]" data-id="element-55" />
                </div>
                <span className="text-slate-500 text-sm font-medium" data-id="element-56">to</span>
                <div className="relative" data-id="element-57">
                  <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" data-id="element-58" />
                  <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} min={startDate} max={today} className="bg-slate-800 border border-slate-700 text-white text-sm py-2 pl-9 pr-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent font-medium shadow-sm hover:bg-slate-750 transition-colors [color-scheme:dark]" data-id="element-59" />
                </div>
              </div>}
          </div>}
      </div>
    </header>;
}